import { ReactNode } from 'react';
import { useModal } from '@/common/components/modal-provider/hooks/useModal';
import {
  ConfirmationDialog,
  ConfirmationVariant,
} from '@/common/components/confirmation-dialog/ConfirmationDialog';

export interface ConfirmationOptions {
  title: ReactNode;
  description?: ReactNode;
  confirmLabel?: ReactNode;
  cancelLabel?: ReactNode;
  additionalActions?: ReactNode;
  variant?: ConfirmationVariant;
}

export const useConfirmation = () => {
  const showModal = useModal();

  const showConfirmation = (options: ConfirmationOptions) => {
    return showModal<boolean>({
      content: ({ resolve }) => (
        <ConfirmationDialog
          {...options}
          onConfirm={() => resolve(true)}
          onCancel={() => resolve(false)}
        />
      ),
    });
  };

  return showConfirmation;
};
